<template>
  <section>
    <Form :model="query" inline>
      <FormItem>
        <Input clearable v-model="query.name" placeholder="模板名称"></Input>
      </FormItem>
      <FormItem>
        <Button icon="ios-search" shape="circle" @click="querySubmit()">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" icon="md-add" shape="circle" @click="newForm()">新增</Button>
      </FormItem>
    </Form>
    <Table border :columns="columns" :data="tableData"></Table>
    <div class="page-div">
      <Page :total="dataCount" :page-size="pageSize" :current="page+1" @on-change="handlePageChange" show-total  show-elevator/>
    </div>
  </section>
</template>

<script>
  import Util from '@/libs/util.js';

  export default {
    data() {
      return {
        name: "TemplateList",
        query: {
          name: ''
        },
        dataCount: 0,
        pageSize: 6,
        page: 0,
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: '模板名称',
            key: 'name'
          },
          {
            title: '套件编码',
            key: 'code'
          },
          {
            title: '套件版本',
            key: 'suiteVersion'
          },
          {
            title: '操作',
            key: 'id',
            render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                  this.edit(params.row.id);
    }
    }
    }, '编辑'),
      h('Button', {
        props: {
          type: 'error',
          size: 'small'
        },
        style: {
          marginLeft: '5px'
        },
        on: {
          click: () => {
          this.delete(params.row.id);
    }
    }
    }, '删除')

    ]);
    }
    },
    ],
      tableData: []
    }
    },
    mounted() {
      this.listTable()
    },
    methods: {
      listTable() {
        let This = this;
        const [url, httpConfig] = [
          '/api/codeTemplateSuitesByCriteria',
          {
            params: {
              page: This.page,
              size: This.pageSize,
              'suiteName.contains': This.query.name
            }
          }
        ]
        This.$http.get(url, httpConfig).then(function (response) {
          This.tableData = [];
          let data = response.data;
          This.dataCount = data.recordsTotal;
          let list = data.data;
          for (let i = 0; i < list.length; i++) {
            let tem = list[i];
            let map = {
              id: tem.id,
              name: tem.suiteName,
              code: tem.suiteCode,
              type: tem.suiteCode,
              suiteType: tem.suiteType,
              suiteVersion: tem.suiteVersion

            };
            This.tableData.push(map);
          }
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      edit(id) {
        this.$router.push({
          name: 'template-edit',
          query: {
            id: id
          }
        })
      },
      delete(id) {
        let This = this;
        this.$Modal.confirm({
          title: '确定删除？',
          onOk() {
            This.$http.delete('/api/codeTemplateSuites/' + id).then(response => {
              if (response.status === 200) {
              This.$Notice.success({
                title: "删除成功"
              });
              This.listTable();
            } else {
              This.$Notice.error({
                title: "删除失败"
              });
            }
          });
          }
        })
      },
      newForm() {
        this.$router.push({
          name: 'template-add'
        });
      },
      querySubmit() {
        this.page = 0;
        this.listTable();
      },
      handlePageChange(current) {
        this.page = current - 1;
        this.listTable();
      }
    }

  }
</script>

<style scoped>
  .page-div {
    display: flex;
    justify-content: flex-end;
    padding-top: 35px;
    padding-right: 50px;
  }
</style>
